import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../Loader";
import { useSelector } from "react-redux";

const AllProducts = () => {
  const [products, setProducts] = useState();
  const [loading, setLoading] = useState(false);
  const [uichange, setuichange] = useState(false);
  const [search, setsearch] = useState("");

  const navigate = useNavigate();

  const hasMounted = useRef(false);

  const { user } = useSelector(state => state.user);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  //for displaying buttons
  const [paginateButtons, setPaginateButtons] = useState(false);

  const [totalProducts, setTotalProducts] = useState();


  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get("/product/total/count");
        if (response.data.success) {
          setTotalProducts(response.data.productsCount);
        }
      } catch (error) {

      }
    })();
  }, [])

  useEffect(() => {
    getAllProducts();
  }, [uichange, page]);

  const getAllProducts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/product/all/by/paginated?page=${page}`);
      setLoading(false);
      if (response.data.success) {
        setProducts(response.data.products)
        setTotalPages(response.data.totalPages);
        response.data.totalPages > 1 ? setPaginateButtons(true) : setPaginateButtons(false);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
    finally {
      setLoading(false);
    }
  }


  const handlePrevious = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  }

  const handleNext = () => {
    if (page < totalPages) {
      setPage(page + 1);
    }
  }


  const handleDelete = async (id) => {
    try {
      const isConfirmed = await showConfirmBox();

      if (isConfirmed) {
        setLoading(true);
        const response = await axios.delete(`product/${id}`);
        if (response.data.success) {
          setLoading(false);
          toast.success(response.data.message);
          setuichange(!uichange);
        }
      }
    } catch (error) {
      console.log("Error while deleting", error);
      setLoading(false);
      toast.error(error.response?.data?.message || "Error deleting product");
    }
  };

  function showConfirmBox() {
    return new Promise((resolve) => {
      console.log("Showing confirmation dialog");
      document.getElementById("confirmDialog").classList.remove("hidden");

      const handleConfirm = (isConfirmed) => {
        resolve(isConfirmed);
        closeConfirmBox();
      };

      document.getElementById("confirmYes").onclick = () => handleConfirm(true);
      document.getElementById("confirmNo").onclick = () => handleConfirm(false);
    });
  }

  function closeConfirmBox() {
    console.log("Closing confirmation dialog");
    document.getElementById("confirmDialog").classList.add("hidden");
  }


  const handleSearch = async (e) => {
    e.preventDefault();
    const value = search;
    console.log(value);
    if (value === "") {
      getAllProducts();
    } else {
      try {
        const response = await axios.get(`/product/search/${value}`);
        if (response.data.success) {
          setProducts(response.data.products);
        }
      } catch (error) {

      }
    }

  }


  if (loading === true) {
    return (
      <>
        <Loader />
      </>
    );
  }

  return (
    <>
      {
        <div className="overflow-x-auto mt-5">
          <div className="flex justify-center gap-3">
            <form onSubmit={handleSearch}>
              <input
                type="search"
                placeholder="Search by product name"
                onChange={(e) => setsearch(e.target.value)}
                className="w-[20vw] h-12 p-4 rounded-lg border-2 border-blue-600 focus:border-none"
              />
              <button type="submit" className="btn btn-primary ml-2">Search</button>
            </form>
          </div>

          <div>
            {totalPages && <p className="text-xl font-bold ml-10">Total Products: {totalProducts}</p>}
          </div>

          <table className="table w-[95%] mx-auto mt-7 overflow-auto">
            {/* head */}
            <thead className="bg-blue-800 text-white">
              <tr className="text-lg">
                <th></th>
                <th>Name</th>
                <th>Material Code</th>
                <th>MRP</th>
                <th>Selling Price</th>
                <th>Buying Price</th>
                <th>Stock</th>
                <th>Gst</th>
                <th>Discount</th>
                <th>Category</th>
                <th>Update</th>
                <th>Delete</th>
              </tr>
            </thead>
            {products?.map((product, index) => {
              return (
                <>
                  <tbody className="border-2 border-blue-400">
                    {/* row 1 */}
                    <tr className="text-base cursor-pointer hover:bg-blue-100">
                      <th className=" text-black font-bold">
                        {index + 1}
                      </th>
                      <th className=" text-blue-700 font-bold">
                        {product?.name}
                      </th>
                      <th className=" text-blue-700 font-bold">
                        {product?.materialCode}
                      </th>
                      <th className=" text-blue-700 font-bold">
                        {product?.MRP}
                      </th>
                      <td className=" text-blue-700 font-bold">
                        {product?.sellingPrice}
                      </td>
                      <td className=" text-blue-700 font-bold">
                        {product?.buyingPrice}
                      </td>
                      <td className={product?.stock <= 0 ? "text-red-600 bg-red-200 rounded-lg font-bold" : " text-blue-700 font-bold"}>
                        {product?.stock}
                      </td>
                      <td className=" text-blue-700 font-bold">
                        {product?.gst}
                      </td>
                      <td className=" text-blue-700 font-bold">
                        {product?.discount}%
                      </td>
                      <td className=" text-blue-700 font-bold">
                        {product?.category?.title}
                      </td>

                      <td>
                        <i
                          onClick={() =>
                            navigate(`/product/update/${product._id}`)
                          }
                          class="fa-solid fa-pen-to-square hover:scale-125 bg-green-700 text-white p-3 rounded-full cursor-pointer"
                        ></i>
                      </td>
                      <td>
                        <i
                          onClick={() => handleDelete(product._id)}
                          class="fa-solid fa-trash hover:scale-125 bg-red-500 text-white p-3 rounded-full cursor-pointer"
                        ></i>
                      </td>

                    </tr>
                  </tbody>
                </>
              );
            })}
          </table>

          {paginateButtons ?
            <>
              <div className="h-20 flex justify-center items-center">
                <button onClick={handlePrevious} className="btn btn-success text-white font-bold" disabled={page === 1}>Previous</button>
                <span className="bg-blue-500 mx-3 p-4 rounded text-white font-bold">Page {page} of {totalPages}</span>
                <button onClick={handleNext} className="btn btn-success text-white font-bold" disabled={page === totalPages}>Next</button>
              </div>
            </>
            :
            null
          }

          <div id="confirmDialog" class="absolute  top-0 right-0 hidden ">
            <div class="bg-gray-300 p-6 rounded-lg shadow-lg text-center">
              <h2 class="text-xl font-semibold mb-4">Confirmation</h2>
              <p class="mb-6">Are you sure you want to delete?</p>
              <div class="flex justify-center gap-4">
                <button
                  id="confirmYes"
                  class="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                >
                  Yes
                </button>
                <button
                  id="confirmNo"
                  class="btn btn-primary text-white px-4 py-2 rounded hover:bg-gray-400"
                >
                  No
                </button>
              </div>
            </div>
          </div>

        </div>
      }
    </>
  );
};

export default AllProducts;
